/* MUI */
import { Box, Button, CircularProgress } from '@mui/material';

/* React */
import React from 'react';

/* NPM */
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ModalFooter } from './ModalFooter';

interface ModalFormFooterProps {
    onClose: () => void;
    onCloseBtnText?: string;
    onSubmitBtnText?: string;
}

/**
 * To use the component, it must be wrapped in a <Form> component
 * which provides the react-hook-form context provider for useFormContext.
 */
export const ModalFormFooter = ({
    onClose,
    onCloseBtnText,
    onSubmitBtnText
}: ModalFormFooterProps) => {
    const { t } = useTranslation();
    const { formState } = useFormContext();
    const { isSubmitting } = formState;

    return (
        <ModalFooter>
            <Button
                data-testid="modalFooterOnCloseBtn"
                data-trackid="modalFooterOnCloseBtn"
                onClick={() => onClose()}
                variant="outlined"
                color="primary"
            >
                {onCloseBtnText || t('Common.close')}
            </Button>
            <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                width="100%"
            >
                {isSubmitting && (
                    <Box marginRight="4px">
                        <CircularProgress size="32px" />
                    </Box>
                )}

                <Button
                    data-testid="modalFooterSubmitBtn"
                    data-trackid="modalFooterSubmitBtn"
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={isSubmitting}
                >
                    {onSubmitBtnText || t('Common.save')}
                </Button>
            </Box>
        </ModalFooter>
    );
};
